import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Bell } from "lucide-react";

export function NotificationBell() {
  const { isAdmin } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);

  const load = useCallback(() => { api.get("/notifications").then(({ data }) => setData(data)).catch(() => {}); }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [load]);

  const openItem = async (n) => {
    if (!n.read) { await api.post(`/notifications/${n.id}/read`).catch(() => {}); }
    setOpen(false);
    load();
    if (n.link && n.link.startsWith("/preventivi")) { navigate(n.link); return; }
    navigate(isAdmin ? "/admin/link-cliente" : "/link-cliente");
  };
  const readAll = async () => { await api.post("/notifications/read-all").catch(() => {}); load(); };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid="notification-bell" className="relative rounded-lg p-2 text-forest/70 hover:bg-sage">
          <Bell className="h-5 w-5" />
          {data.unread > 0 && (
            <span data-testid="notification-badge" className="absolute -right-0.5 -top-0.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-terracotta px-1 text-[10px] font-semibold text-white">
              {data.unread > 9 ? "9+" : data.unread}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0">
        <div className="flex items-center justify-between border-b border-border/60 px-4 py-2.5">
          <span className="font-heading text-sm font-semibold text-forest">Notifiche</span>
          {data.unread > 0 && <button onClick={readAll} className="text-xs text-terracotta hover:underline">Segna tutte lette</button>}
        </div>
        <div className="max-h-80 overflow-y-auto">
          {data.items.length === 0 && <div className="px-4 py-8 text-center text-sm text-muted-foreground">Nessuna notifica</div>}
          {data.items.map((n) => (
            <button key={n.id} data-testid={`notification-item-${n.id}`} onClick={() => openItem(n)}
              className={`block w-full border-b border-border/40 px-4 py-3 text-left transition-colors hover:bg-sage/40 ${n.read ? "opacity-60" : ""}`}>
              <div className="flex items-start gap-2">
                {!n.read && <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-terracotta" />}
                <div className={n.read ? "pl-4" : ""}>
                  <div className="text-sm font-medium text-forest">{n.title}</div>
                  <div className="text-xs text-muted-foreground">{n.body}</div>
                </div>
              </div>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
